import { Path } from "react-native-svg";
import { createIcon } from "../Icon";

export const ChargeUltraV2SquareIcon = createIcon({
	viewBox: "0 0 24 24",
	path: (
		<>
			<Path
				d="M24 3.1647V20.8348C24 22.5831 22.5826 24 20.8348 24H3.16516C1.41691 24 0 22.5831 0 20.8348V3.1647C0 1.41691 1.41691 0 3.16516 0H20.8348C22.5826 0 24 1.41691 24 3.1647Z"
				stroke="transparent"
			/>
			<Path
				d="M10.5402 19.9959C9.73431 19.4993 10.7526 16.8609 11.0501 15.0669C11.2235 14.0207 8.98055 14.7026 8.34624 14.5058C6.86297 14.0459 8.392 11.4464 11.1503 8.56041C13.9091 5.67443 15.3067 4.67536 16.2852 5.00808C17.2632 5.34125 16.1095 8.45607 15.682 10.6762C15.4701 11.775 17.8824 11.0093 18.4939 11.2867C19.3904 11.6935 19.3282 12.8015 15.8427 16.5548C12.3571 20.308 11.1439 20.3675 10.5407 19.9959"
				fill="white"
				stroke="transparent"
			/>
			<Path
				d="M21.0394 6.98325H20.2321V6.17594C20.2321 5.83453 19.9556 5.55811 19.6142 5.55811C19.2728 5.55811 18.9964 5.83499 18.9964 6.17594V6.98325H18.1891C17.8481 6.98325 17.5712 7.25968 17.5712 7.60109C17.5712 7.9425 17.8477 8.21892 18.1891 8.21892H18.9964V9.02623C18.9964 9.36719 19.2728 9.64407 19.6142 9.64407C19.9556 9.64407 20.2321 9.36765 20.2321 9.02623V8.21892H21.0394C21.3808 8.21892 21.6572 7.94204 21.6572 7.60109C21.6572 7.26013 21.3808 6.98325 21.0394 6.98325Z"
				fill="#FFFB0A"
				stroke="transparent"
			/>
			<Path
				d="M7.79064 10.9008H2.19395C1.81501 10.9008 1.50747 10.5933 1.50747 10.2143C1.50747 9.83538 1.81501 9.52783 2.19395 9.52783H7.79064C8.16958 9.52783 8.47713 9.83538 8.47713 10.2143C8.47713 10.5933 8.16958 10.9008 7.79064 10.9008Z"
				fill="#FFFB0A"
				stroke="transparent"
			/>
			<Path
				d="M6.27992 13.7433H3.5953C3.21636 13.7433 2.90881 13.4358 2.90881 13.0568C2.90881 12.6779 3.21636 12.3704 3.5953 12.3704H6.27992C6.65886 12.3704 6.9664 12.6779 6.9664 13.0568C6.9664 13.4358 6.65886 13.7433 6.27992 13.7433Z"
				fill="#FFFB0A"
				stroke="transparent"
			/>
			<Path
				d="M9.85011 8.05876H5.0589C4.67996 8.05876 4.37241 7.75122 4.37241 7.37228C4.37241 6.99334 4.67996 6.68579 5.0589 6.68579H9.85011C10.2291 6.68579 10.5366 6.99334 10.5366 7.37228C10.5366 7.75122 10.2291 8.05876 9.85011 8.05876Z"
				fill="#FFFB0A"
				stroke="transparent"
			/>
		</>
	),
});
